import shohozLoadingGif from '../../assets/gif/loader.gif'
import '../../assets/css/loader.css';

function Laoder() {
    return (
        <div className='shohoz-loading-container'>
            <img
                src={shohozLoadingGif}
                alt="shohoz-loading-logo"
            />
            {/* <p>Searching for parks</p> */}
        </div>
    );
}

export default Laoder;
